// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__35fvW","selects":"Documents_selects__3z39t"};